import styled, { keyframes } from 'styled-components';

import { FTUX_ANIM } from '../../../../theme/ftux-tokens';
import { IMPORTANT_NOW, LUMIO, REDUCED_MOTION, SPACE } from '../../../../theme/tokens';

/** How many lines of the pick's line show (the prototype's three); the rest is cut with an ellipsis, the whole line in
 *  the tooltip. */
const PICK_BODY_LINES = 3;
/** 13px type (the user, 2026-10-23), its line height with it. */
const PICK_BODY_FONT_PX = 13;
const PICK_BODY_LINE_PX = 18;

/** A cut line's tooltip, never wider than this. */
export const PICK_TIP_MAX_W_PX = 320;

/** Over the studio's chrome and the FTUX's layers, as the shared Toast (the area has no z-index scale). */
const TIP_Z = 2100;

/**
 * The card's line, a size up from Figma's 12px, its line height with it; always three lines tall, a shorter line
 * too (the card keeps one height whatever its copy), a cut line telling so by its pointer. A step stronger in light,
 * so it keeps 4.5:1 on the white card and its deeper corner.
 */
export const PickBody = styled.p<{ $cut: boolean }>`
  display: -webkit-box;
  height: ${PICK_BODY_LINES * PICK_BODY_LINE_PX}px;
  margin: 0;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${PICK_BODY_LINES};
  line-clamp: ${PICK_BODY_LINES};
  font-size: ${PICK_BODY_FONT_PX}px;
  font-weight: 300;
  line-height: ${PICK_BODY_LINE_PX}px;
  opacity: 0.7;
  cursor: ${({ $cut }) => ($cut ? 'help' : 'auto')};
  outline: none;

  :root[data-ows-theme='light'] & {
    opacity: 0.85;
  }

  &:focus-visible {
    border-radius: 4px;
    box-shadow: 0 0 0 2px ${LUMIO.link};
  }
`;

const tipIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

/** The whole of a cut line in a small tooltip over it (under it near the screen's top), fixed on the page so the
 *  strip and the card never clip it. */
export const PickBodyTip = styled.div<{ $below: boolean }>`
  position: fixed;
  z-index: ${TIP_Z};
  max-width: ${PICK_TIP_MAX_W_PX}px;
  padding: ${SPACE[8]} ${SPACE[12]};
  border-radius: 10px;
  border: 1px solid ${IMPORTANT_NOW.cardBorder};
  background: ${LUMIO.userBubbleBg};
  color: ${IMPORTANT_NOW.cardTitle};
  font-size: 13px;
  line-height: 18px;
  box-shadow: ${LUMIO.tipShadow};
  transform: ${({ $below }) => ($below ? 'none' : 'translateY(-100%)')};
  pointer-events: none;
  animation: ${tipIn} ${FTUX_ANIM.TIP_IN_MS}ms ease-out;

  ${REDUCED_MOTION} {
    animation: none;
  }
`;
